module.exports = __webpack_public_path__ + "img/guide-btn-2.4ec5b329.png";